<template>
  <Badge v-if="badge" :variant="badge.variant" class="px-1.5 py-0 text-[10px] font-medium normal-case">
    {{ badge.label }}
  </Badge>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { UserTaskProductArea } from '@/api/entity_types/UserTask';
import { Badge, type BadgeVariants } from '@/components/ui/badge';

type Variant = NonNullable<BadgeVariants['variant']>;
type ProductAreaBadge = { label: string; variant: Variant };

const props = defineProps<{
  productArea: UserTaskProductArea;
}>();

const PRODUCT_AREA_BADGE: Record<UserTaskProductArea, ProductAreaBadge | null> = {
  generic: null,
  recruiting: { label: 'Recruiting', variant: 'green' },
  onboarding: { label: 'Onboarding', variant: 'blue' },
  team_management: { label: 'Team Management', variant: 'indigo' },
  training: { label: 'Training', variant: 'purple' },
  offboarding: { label: 'Offboarding', variant: 'yellow' },
};

const badge = computed(() => PRODUCT_AREA_BADGE[props.productArea]);
</script>
